import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppAssistPanel } from "./AppAssistPanel";
import { AppAssistView } from "./AppAssistView";

/** Event DOM operations shared by the shell and the all-contact AI panel. */
export class AppEventTarget {
    public static OnClick = (Id: string, Then: (Ev: Event) => void, Where: string = "AppEventTarget.OnClick"): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const El: HTMLElement | null = document.getElementById(Id);
            if (El !== null) { El.addEventListener("click", Then); }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, Where); }
    };

    public static Closest = (Ev: Event, Selector: string, Where: string = "AppEventTarget.Closest"): Element | null => {
        const Core = getCoreUtils();
        if (Core.KErrorMode === true) { return null; }
        let Found: Element | null = null;
        try {
            const Target = Ev.target as EventTarget | null;
            if (Target !== null && (Target instanceof Element) === true) {
                const El: Element = Target as Element;
                Found = El.closest(Selector);
            }
        } catch (e) { Core.KGlobalErrorHandler(e, Where); }
        return Found;
    };
}

/**
 * A click inside an AI log, for the contact panel (`AppMain.OnAssistClick`) and the all-contact panel
 * (`AppAskAll.OnLogClick`): a source citation goes to `Cite` (when the host has one), anything else with an act
 * attribute goes to the panel's own `Act`. `Where` is the caller's label for the `Closest` lookups.
 */
export class AppAssistLogClick {
    public static Route = (Ev: Event, Where: string, Panel: AppAssistPanel | null,
        Cite: ((ChatId: string, MessageId: string) => void) | undefined): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Source: Element | null = AppEventTarget.Closest(Ev, "[data-search-chat][data-search-message]", Where);
            if (Source !== null && Cite !== undefined) {
                Cite(nz(Source.getAttribute("data-search-chat")), nz(Source.getAttribute("data-search-message")));
                return;
            }
            const Button: Element | null = AppEventTarget.Closest(Ev, "[" + AppAssistView.ActAttr + "]", Where);
            if (Button === null || Panel === null) { return; }
            Panel.Act(nz(Button.getAttribute(AppAssistView.ActAttr)),
                parseInt(nz(Button.getAttribute(AppAssistView.IndexAttr)), 10));
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppAssistLogClick.Route"); }
    };
}
